// function numberWithCommas(x) {
//     x = x.toString();
//     var pattern = /(-?\d+)(\d{3})/;
//     while (pattern.test(x))
//         x = x.replace(pattern, "$1,$2");
//     return x;

// }
// export default  numberWithCommas;

//import React from 'react';

const numberWithCommas = (x) => {
       x = x.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x))
        x = x.replace(pattern, "$1,$2"); 
        return x;
}
 
export default numberWithCommas;